<header class="header d-flex flex-column justify-content-between align-items-center">
  <div class="child-container w-100">
    <div class="d-flex flex-row align-items-center w-100">
      <div class="logo">
        <img [src]="iconImages['comforce_icon']" class="cursor-pointer" alt="ComForce Logo" />
      </div>
    
      <!-- Desktop Navigation -->
      <nav class="nav desktop-nav">
        <div class="d-flex align-items-center cursor-pointer home-trigger"
          routerLinkActive="home-active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="'/home'">
          <img class="m-2 home-icon" [src]="iconImages['home_icon']" alt="Home" />
          <span>Home</span>
        </div>
        <div class="d-flex align-items-center cursor-pointer conversation-trigger"
             [class.conv-open]="convOpen"
             [class.conv-active]="isConversationalActive()"
             [matMenuTriggerFor]="convMenu">
          <img class="m-2 conv-icon" [src]="iconImages['conversional_icon']" alt="Conversional AI" />
          <span>Conversational AI</span>
          <img class="ms-2 caret-icon" [src]="iconImages['caret_icon']" alt="Down Icon" />
        </div>
        <mat-menu #convMenu="matMenu" [overlapTrigger]="false" panelClass="conversation-menu-panel" (menuOpened)="convOpen=true" (menuClosed)="convOpen=false">
          <button mat-menu-item [routerLink]="'/call-list'" [ngClass]="{'menu-item-active': isActive('/call-list')}">
            <span>Call List</span>
          </button>
          <button mat-menu-item [routerLink]="'/agents-catalogs'" [ngClass]="{'menu-item-active': isActive('/agents-catalogs')}">
            <span>Agent Catalog</span>
          </button>
          <button mat-menu-item [routerLink]="'/dashboard'" [ngClass]="{'menu-item-active': isActive('/dashboard')}">
            <span>Dashboard</span>
          </button>
          <button mat-menu-item [routerLink]="'/killswitch-logs'" [ngClass]="{'menu-item-active': isActive('/killswitch-logs')}">
            <span>Kill Switch Logs</span>
          </button>
        </mat-menu>
      </nav>

      <!-- Mobile Navigation -->
      <div class="mobile-menu-trigger" [matMenuTriggerFor]="mobileMenu">
        <span class="material-icons">menu</span>
      </div>
      <mat-menu #mobileMenu="matMenu" [overlapTrigger]="false" panelClass="mobile-menu-panel">
        <button mat-menu-item [routerLink]="'/home'" [ngClass]="{'menu-item-active': isActive('/home')}">
          <span>Home</span>
        </button>
        <button mat-menu-item [routerLink]="'/call-list'" [ngClass]="{'menu-item-active': isActive('/call-list')}">
          <span>Call List</span>
        </button>
        <button mat-menu-item [routerLink]="'/agents-catalogs'" [ngClass]="{'menu-item-active': isActive('/agents-catalogs')}">
          <span>Agent Catalog</span>
        </button>
        <button mat-menu-item [routerLink]="'/dashboard'" [ngClass]="{'menu-item-active': isActive('/dashboard')}">
          <span>Dashboard</span>
        </button>
        <button mat-menu-item [routerLink]="'/killswitch-logs'" [ngClass]="{'menu-item-active': isActive('/killswitch-logs')}">
          <span>Kill Switch Logs</span>
        </button>
      </mat-menu>
    
      <div class="search-profile ms-auto d-flex align-items-center">
        <div class="queue-count-badge" *ngIf="user?.isAuthenticated">
          <span class="queue-label">Calls in Queue</span>
          <span class="queue-separator">:</span>
          <span class="queue-number">{{ queueCount }}</span>
        </div>
        <div class="kill-switch-control"
             *ngIf="user?.isAuthenticated"
             [class.kill-switch-control--on]="aiActive"
             [class.kill-switch-control--loading]="killSwitchLoading"
             [matTooltip]="aiActive ? 'AI outbound calls are ON across all pools.' : 'AI outbound calls are paused. No new calls will start.'"
             matTooltipPosition="below">
          <span class="material-icons kill-switch-control__phone">call</span>
          <span class="kill-switch-control__label">Kill switch</span>
          <button
            type="button"
            class="kill-switch-control__info-btn"
            aria-label="What does this switch do?"
            [matMenuTriggerFor]="killSwitchInfoMenu">
            <span class="material-icons kill-switch-control__info-icon">info_outline</span>
          </button>
          <div class="kill-switch-control__toggle-wrap">
            <mat-slide-toggle
              class="kill-switch-control__toggle"
              [checked]="aiActive"
              [disabled]="killSwitchLoading"
              (change)="onKillSwitchToggle($event)">
            </mat-slide-toggle>
            <mat-progress-spinner
              *ngIf="killSwitchLoading"
              class="kill-switch-control__spinner"
              mode="indeterminate"
              [diameter]="18"
              [strokeWidth]="2"
              aria-label="Updating kill switch">
            </mat-progress-spinner>
          </div>
        </div>
        <mat-menu
          #killSwitchInfoMenu="matMenu"
          [overlapTrigger]="false"
          xPosition="before"
          yPosition="below"
          panelClass="kill-switch-info-panel">
          <div class="ks-info" (click)="$event.stopPropagation()">
            <div class="ks-info__header">
              <span class="material-icons ks-info__header-icon">info_outline</span>
              <span class="ks-info__header-title">What does this switch do?</span>
            </div>
            <div class="ks-info__desc">
              Controls whether the AI can make outbound calls across your entire contact centre &mdash; All pools at once.
            </div>
            <div class="ks-info__state ks-info__state--on">
              <span class="ks-info__dot ks-info__dot--on"></span>
              <div class="ks-info__state-body">
                <span class="ks-info__state-label">Switch On</span><span class="ks-info__state-text"> &mdash; AI actively makes outbound calls based on each pool's own settings.</span>
              </div>
            </div>
            <div class="ks-info__state ks-info__state--off">
              <span class="ks-info__dot ks-info__dot--off"></span>
              <div class="ks-info__state-body">
                <span class="ks-info__state-label">Switch Off</span><span class="ks-info__state-text"> &mdash; No new AI calls are started. Any call in progress will finish, then stop. All pool-level switches are paused.</span>
              </div>
            </div>
          </div>
        </mat-menu>
        <div class="global-search">
          <span class="material-icons global-search-icon">search</span>
          <input class="global-search-input" type="text" placeholder="Global Search" (input)="onGlobalSearch($event)" />
        </div>
        <div class="user-pill cursor-pointer" *ngIf="user?.isAuthenticated" [matMenuTriggerFor]="userMenu">
          <div class="avatar" [ngClass]="{ 'avatar-initials': !user?.userImage }">
            <img *ngIf="user?.userImage" [src]="user?.userImage" alt="avatar" />
            <span *ngIf="!user?.userImage">{{ (user?.userName || 'U').charAt(0) }}</span>
            <span class="status-dot" aria-label="online"></span>
          </div>
          <div class="user-meta">
            <div class="user-name">{{ user?.userName }}</div>
            <div class="user-handle">{{ user?.userEmail }}</div>
          </div>
          <span class="material-icons ms-2" style="font-size: 18px; color: #9CA3AF;">arrow_drop_down</span>
        </div>
        <mat-menu #userMenu="matMenu" [overlapTrigger]="false" panelClass="user-menu-panel">
          <button mat-menu-item (click)="logout()">
            <span class="material-icons" style="margin-right: 8px; font-size: 20px;">logout</span>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</header>